var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconCrown = function SvgIconCrown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.098 15.395a29.5 29.5 0 0 1 5.804 0 1 1 0 0 0 .196-1.99 31.6 31.6 0 0 0-6.196 0 1 1 0 0 0 .196 1.99"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M12 2.794a1.75 1.75 0 0 0-1.53.903L7.824 8.464l-4.54-2.018-.004-.002A1.75 1.75 0 0 0 .874 8.453l2.38 10.15.003.008a1.76 1.76 0 0 0 2.172 1.282l.004-.001a24.6 24.6 0 0 1 13.125 0l.004.001a1.76 1.76 0 0 0 2.172-1.282l.002-.007 2.39-10.147v-.003a1.752 1.752 0 0 0-2.407-2.01l-.003.002-4.54 2.018-2.644-4.767A1.75 1.75 0 0 0 12 2.794M9.462 9.635 12 5.06l2.538 4.575.006.01a1.76 1.76 0 0 0 2.237.74l.004-.002 4.28-1.904-2.217 9.42a26.6 26.6 0 0 0-13.704-.001l-2.21-9.42 4.282 1.905.003.001a1.76 1.76 0 0 0 2.237-.738z",
    clipRule: "evenodd"
  }))));
};
export default SvgIconCrown;